import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Arabic is the default language on every page load. The user can switch to
// English mid-session via the EN/AR toggle (changeLanguage updates the live
// i18n state and the html lang attribute), but we intentionally do NOT cache
// the choice to localStorage and we do NOT run a language detector — the next
// page load always restarts in Arabic. This matches the product expectation
// for a Saudi-first platform.
i18n
  .use(initReactI18next)
  .init({
    lng: 'ar',
    fallbackLng: 'ar',
    supportedLngs: ['en', 'ar'],
    defaultNS: 'common',
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    returnNull: false,
  });

export default i18n;
